import { render, staticRenderFns } from "./customFieldString.vue?vue&type=template&id=11cbf5b8&scoped=true"
import script from "./customFieldString.vue?vue&type=script&lang=js"
export * from "./customFieldString.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cbf5b8",
  null
  
)

export default component.exports